import { ApplianceDetailsAdditionalAppliancesFormValue } from './appliance-details-additional-appliances-form-value.type';

export interface ApplianceDetailsAdditionalAppliancesFormConfig {
  initialValue: Partial<ApplianceDetailsAdditionalAppliancesFormValue>;
}
